import { TaskTemplateActionTypes } from './constants';

const INIT_STATE = {
    data: [],
    loading: false,
    error: null,
    updateSuccess: null,
    createSuccess: null,
};

const TaskTemplate = (state = INIT_STATE, action) => {
    switch (action.type) {
        case TaskTemplateActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TaskTemplateActionTypes.CREATE_TEMPLATE:
                    return { ...state, data: action.payload.data, loading: false, createSuccess: true };
                case TaskTemplateActionTypes.GET_TEMPLATES:
                    return { ...state, data: action.payload.data, loading: false };
                case TaskTemplateActionTypes.GET_TEMPLATE_BY_ID:
                    return { ...state, data: action.payload.data, loading: false };
                case TaskTemplateActionTypes.GET_TEMPLATES_BY_USER:
                    return { ...state, data: action.payload.data, loading: false };
                case TaskTemplateActionTypes.UPDATE_TEMPLATE:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                default:
                    return { ...state };
            }
        case TaskTemplateActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TaskTemplateActionTypes.CREATE_TEMPLATE:
                    return { ...state, error: action.payload, loading: false };
                case TaskTemplateActionTypes.GET_TEMPLATES:
                    return { ...state, error: action.payload, loading: false };
                case TaskTemplateActionTypes.GET_TEMPLATE_BY_ID:
                    return { ...state, error: action.payload, loading: false };
                case TaskTemplateActionTypes.GET_TEMPLATES_BY_USER:
                    return { ...state, error: action.payload, loading: false };
                case TaskTemplateActionTypes.UPDATE_TEMPLATE:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                default:
                    return { ...state };
            }
        case TaskTemplateActionTypes.CREATE_TEMPLATE:
            return { ...state, loading: true };
        case TaskTemplateActionTypes.GET_TEMPLATES:
            return { ...state, loading: true };
        case TaskTemplateActionTypes.GET_TEMPLATE_BY_ID:
            return { ...state, loading: true };
        case TaskTemplateActionTypes.GET_TEMPLATES_BY_USER:
            return { ...state, loading: true };
        case TaskTemplateActionTypes.UPDATE_TEMPLATE:
            return {
                ...state,
                id: action.payload.id,
                data: action.payload.data,
                loading: false,
            };
        case TaskTemplateActionTypes.RESET_TEMPLATES:
            return INIT_STATE;
        default:
            return { ...state, updateSuccess: null, createSuccess: null };
    }
};

export default TaskTemplate;
